// 所见即判定 (honest silhouettes) — the dark-rollout gate (TECH_SPEC §4bis.23).
//
// A clone of §4bis.22's `peakEnabled` under its own salt. The feature itself
// is pure rendering (game/geometry.ts + render.ts + the death-frame flash in
// session.ts); this module only answers "is this device in the arm?". At
// `FAIR_PCT=0` nobody is in and rendering is pixel-identical to today — a
// tested property the Layer-3 baselines depend on.

import { hashString, mix32 } from './rng';

/**
 * Rollout salt. Deliberately NOT `card-ab-v1` (experiment.ts), NOT
 * `rival-ladder-v1` (ladder.ts) and NOT `peak-v1` (peak.ts): the same device
 * id under a different salt is an *independent* assignment, so being in the
 * fair arm tells you nothing about the other three experiments. Pinned by a
 * golden vector in the tests.
 */
export const FAIR_ID = 'fair-v1';

/** Stable bucket 0–99 for a device: `mix32(fnv1a("fair-v1:" + id)) % 100`. */
export function fairBucket(deviceId: string): number {
  return mix32(hashString(`${FAIR_ID}:${deviceId}`)) % 100;
}

/**
 * Is this device in the fair arm? `pct` is the server's `fairPct` (0 = dark,
 * 100 = everyone). Anything unparseable is 0: fail closed on both wire ends.
 */
export function fairEnabled(deviceId: string, pct: number | undefined | null): boolean {
  if (typeof pct !== 'number' || !Number.isFinite(pct) || pct <= 0) return false;
  if (pct >= 100) return true;
  return fairBucket(deviceId) < pct;
}
